import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasArcRender } from "./arc-render";

import { DefaultBaseInteractiveRenderContribution } from "./contributions";

import { ArcRenderContribution } from "./contributions/constants";

import { ArcRender, GraphicRender } from "./symbol";

const loadedArcModuleContexts = new WeakSet;

export function bindArcRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedArcModuleContexts, bind) || (bind(DefaultCanvasArcRender).toDynamicValue((({container: container}) => new DefaultCanvasArcRender(createContributionProvider(ArcRenderContribution, container)))).inSingletonScope(), 
    bind(ArcRender).toService(DefaultCanvasArcRender), bind(GraphicRender).toService(ArcRender), 
    bind(ArcRenderContribution).toService(DefaultBaseInteractiveRenderContribution), 
    bindContributionProvider(bind, ArcRenderContribution));
}

export const arcModule = bindArcRenderModule;
//# sourceMappingURL=arc-module.js.map
